<script lang="ts">
import {defineComponent} from 'vue'
import StudentSelect from "@/components/Global/ObjectSelect/StudentSelect.vue"
import Button from "primevue/button"
import CourseSelect from "@/components/Global/ObjectSelect/CourseSelect.vue"
import Dialog from "primevue/dialog"
import ToggleSwitch from "primevue/toggleswitch"
import {fetchWrapper} from "@/helpers/fetchWrapper"
import backendRoutes from "@/backendRoutes"
import {CourseRegistration} from "@/interfaces/courseregistration"
import isNull from "@/helpers/isNull"
import FormField from "@/components/Global/Form/FormField.vue";

export default defineComponent({
  name: "CourseRegistrationModal",
  components: {
    FormField,
    CourseSelect,
    StudentSelect,
    Button,
    Dialog,
    ToggleSwitch
  },
  props: {
    student: {
      type: Object,
      required: false
    },
    course: {
      type: Object,
      required: false
    },
  },
  data() {
    return {
      courseRegistration: {isFree: false} as CourseRegistration,
      isVisible: false as boolean,
      hasTryToSave: false as boolean,
    }
  },
  computed: {
    isValid(): boolean {
      return !isNull(this.courseRegistration.student) && !isNull(this.courseRegistration.course)
    }
  },
  mounted() {
    if(this.student) this.courseRegistration.student = this.student
    if(this.course) this.courseRegistration.course = this.course
  },
  methods: {
    open() {
      if(this.student) this.courseRegistration.student = this.student
      else this.courseRegistration.student = undefined
      if(this.course) this.courseRegistration.course = this.course
      else this.courseRegistration.course = undefined
      this.courseRegistration.isFree = false
      this.isVisible = true
    },
    close() {
      this.isVisible = false
      this.courseRegistration.isFree = false
    },
    async postItemApi() {
      let errorCheck = false

      let courseRegistration = Object({...this.courseRegistration})
      if (this.courseRegistration?.student) courseRegistration.student = this.courseRegistration.student["@id"]
      if (this.courseRegistration?.course) courseRegistration.course = this.courseRegistration.course["@id"]

      await fetchWrapper.post(backendRoutes.course_registration_list, courseRegistration).catch((error) => {
        if(error == "student_too_old") error = this.$t('admin_components.course_registration_modal.messages.errors.student_too_old')
        else if(error == "student_too_young") error = this.$t('admin_components.course_registration_modal.messages.errors.student_too_young')
        else if(error == "student_already_registered") error = this.$t('admin_components.course_registration_modal.messages.errors.student_already_registered')
        else if(error == "course_full") error = this.$t('admin_components.course_registration_modal.messages.errors.course_full')

        this.$toast.add({severity:'error', summary: this.$t('admin_components.course_registration_modal.messages.post_error_title'),
          detail: error, life: 5000});
        errorCheck = true
      })
      if(!errorCheck){
        this.$toast.add({severity:'success', summary: this.$t('admin_components.course_registration_modal.messages.save_success.title'), detail: this.$t('admin_components.course_registration_modal.messages.save_success.content'), life: 5000})
        this.close()
        this.$emit('formSubmitted')
      }
    }
  },
  emits: ['formSubmitted']
})
</script>

<template>
  <Dialog v-model:visible="isVisible" modal :header="$t('admin_components.course_registration_modal.view.title')" :draggable="true">
    <form ref="form" @submit.prevent="postItemApi">
      <FormField :label="$t('admin_components.course_registration_modal.view.student')">
        <StudentSelect :disabled="this.student != undefined" v-model="courseRegistration.student" />
      </FormField>
      <FormField :label="$t('admin_components.course_registration_modal.view.course')">
        <CourseSelect :disabled="this.course != undefined" v-model="courseRegistration.course" />
      </FormField>
      <FormField :label="$t('admin_components.course_registration_modal.view.is_free')">
        <ToggleSwitch v-model="courseRegistration.isFree" />
      </FormField>
      <Button type="submit" :label="$t('admin_components.course_registration_modal.view.button')" :disabled="!isValid" />
    </form>
  </Dialog>
</template>

<style scoped lang="scss">
@use "@/styles/admin/administration_modal_common.scss";
</style>
